<div class="header">
  {{ 'app.evaluation_tab.summary_details.score_tooltip_title' | translate }}
</div>

@for (row of rows(); track row.score) {
  <div class="row">
    <rt-evaluation-rating-score
      class="label"
      [evaluationScale]="evaluationScale()"
      [score]="row.score"
      [showIcon]="showIcon()"
      iconSize="medium"
      fontSize="default"
      fontWeight="default"
      textColor="strong"
    />

    <div class="votes">
      <rt-admins-avatars
        [admins]="$any(row.reviewers)"
        [stacked]="true"
        [limit]="3"
        [moreButtonAsCounter]="true"
        [counterAvatarTemplate]="counterAvatarTemplate"
        avatarSize="small-x"
      />

      <ng-template #counterAvatarTemplate>
        <div class="avatar-counter">{{ row.reviewers.length }}</div>
      </ng-template>

      <span
        class="count"
        [innerHTML]="
          'app.evaluation_tab.summary_details.votes_count' | translate: { count: row.answerCount }
        "
      ></span>
    </div>
  </div>
}
